module.exports = __webpack_public_path__ + "static/media/checkmark_new.b6bab44a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkmark_new.svg
// module id = 18
// module chunks = 0